import React from 'react';
import InputField from '../../../Forms/Input/InputField';

interface CryptoPaymentSectionProps {
  voucherCode: string;
  onVoucherChange: (value: string) => void;
}

const CryptoPaymentSection: React.FC<CryptoPaymentSectionProps> = ({
  voucherCode,
  onVoucherChange,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onVoucherChange(e.target.value);
  };

  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <InputField
        label="Código de Transacción Cripto"
        name="cryptoVoucher"
        iconKey="payment" // 👈 puedes reemplazarlo por un icono específico si lo tienes
        type="text"
        placeholder="Ingrese el código de la transacción cripto"
        value={voucherCode}
        onChange={handleChange}
      />
    </div>
  );
};

export default CryptoPaymentSection;
